import { EWorldColor } from 'static/config/worldVariables';

export interface ICoordinates {
    lat: number;
    lng: number;
}

export const MAP_STYLES = {
    default: 'default',
    outdoor: 'outdoor',
    satellite: 'satellite'
};

export const DEFAULT_COLOR = EWorldColor.RED;

export const DEFAULT_MAP_VALUES = Object.values(MAP_STYLES);
